import { FC } from 'react'

import LabelAndInfo from '../LabelAndInfo'
import { formatDayMonthDate } from '../../../utils'

export type PurchasedOnProps = {
  storeName: string | undefined | null
  createdAt: string
  purchasedAt: string | null
}

const PurchasedOn: FC<PurchasedOnProps> = ({
  storeName,
  createdAt,
  purchasedAt,
}) => {
  if (storeName === 'Babylist') {
    if (purchasedAt) {
      return (
        <LabelAndInfo
          info={formatDayMonthDate(purchasedAt)}
          label="Purchased on"
        />
      )
    }
    return (
      <LabelAndInfo info={formatDayMonthDate(createdAt)} label="Reserved on" />
    )
  }

  return (
    <LabelAndInfo
      info={formatDayMonthDate(createdAt)}
      label="Marked as purchased on"
    />
  )
}

export default PurchasedOn
